var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('i-col',{attrs:{"span":"24"}},[_c('Divider',{attrs:{"dashed":""}},[_c('span',{staticClass:"divider-text"},[_vm._v("任务汇总")])]),_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.taskSummary,"columns":_vm.dataColumns}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }